<template>
  <div>
    <!-- finish annotation -->
    <b-modal
      id="popupFinishAnnotation"
      size="lg"
      no-close-on-backdrop
      hide-header
      hide-footer
      hide-header-close
      centered
    >
      <div class="col-md-12 text-center">
        <ErrorsMessages :errors="errors" />
        <div class="text-right">
          <vs-button
            @click="$bvModal.hide('popupFinishAnnotation')"
            class="btn-close"
            type="relief"
            >X</vs-button
          >
        </div>
        <h6 class="upper-text">Deseja realmente finalizar o cuidado?</h6>
        <h6 class="worksansr upper-text">
          Ao confirmar, não poderá realizar quaisquer alterações.
        </h6>
      </div>
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 text-center"
        v-if="!care_has_shift_change_init || !care_has_shift_change_end"
      >
        <WarningMessage
          v-if="!care_has_shift_change_init"
          message=" Não se esqueça de fazer o assumo do plantão."
        />
        <WarningMessage
          v-if="!care_has_shift_change_end"
          message=" Não se esqueça de fazer o encerramento do plantão."
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
        <confirmation-dialog
          v-if="$store.state.online"
          message-title="FINALIZAR?"
          message-body="Deseja realmente finalizar o cuidado? Ao confirmar, não podera realizar quaisquer alterações!"
          open-class="btn-notcertified"
          open-left-icon="fa-check"
          open-text="FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
          @yes="finishCareAnnotation"
        />
      </div>
      <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-center">
          <vs-button
            @click="handleSerasaAnnotation"
            class="btn-save"
            type="relief"
            >COM COM ASSINATURA ELETRÔNICA</vs-button
          >
        </div> -->
    </b-modal>
    <!-- /finish annotation -->
    <v-alert
      v-if="!permission('read', 'resident_annotation')"
      border="left"
      class="v-warning m-0 pb-2"
    >
      <h6>Você não tem permissão!!!</h6>
    </v-alert>
    <div v-if="permission('read', 'resident_annotation')">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-md-8">
            <h6 class="mb-3">NOME: {{ resident_name }}</h6>
          </div>
          <div class="col-md-4 text-right" v-if="$store.state.online">
            <confirmation-dialog
              v-if="statusCare == 'A' && $store.state.online"
              message-title="EXCLUIR?"
              message-body="Deseja realmente excluir a anotação?"
              open-class="btn-delete"
              open-left-icon="fa-trash"
              open-text="EXCLUIR"
              @yes="deleteAnnotation"
            />
          </div>
        </div>
        <form method="post">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                v-if="care.finish_by_check == 0"
                @click="errors = []"
                :class="[
                  'nav-link link-annotation-annotation',
                  care.finish_by_check == 0 && 'active',
                ]"
                id="nav-passagem-de-plantao"
                data-toggle="tab"
                href="#passagem-de-plantao"
                role="tab"
                aria-controls="passagem-de-plantao"
                :aria-selected="care.finish_by_check == 0"
                >PASSAGEM DE PLANTÃO</a
              >
              <a
                @click="errors = []"
                :class="[
                  'nav-link link-annotation-annotation',
                  care.finish_by_check == 1 && 'active',
                ]"
                id="nav-anotacao"
                data-toggle="tab"
                href="#anotacao"
                role="tab"
                aria-controls="anotacao"
                :aria-selected="care.finish_by_check == 1"
                >Anotação</a
              >
              <a
                v-if="care.finish_by_check == 0"
                @click="errors = []"
                class="nav-link link-annotation-annotation"
                id="nav-alimentacao"
                data-toggle="tab"
                href="#alimentacao"
                role="tab"
                aria-controls="alimentacao"
                aria-selected="false"
                >Alimentação</a
              >
              <a
                v-if="care.finish_by_check == 0"
                @click="errors = []"
                class="nav-link link-annotation-annotation"
                id="nav-banho"
                data-toggle="tab"
                href="#banho"
                role="tab"
                aria-controls="banho"
                aria-selected="false"
                >Banho</a
              >
              <!-- <a
                @click="errors = []"
                class="nav-link link-annotation-annotation"
                id="nav-curativo"
                data-toggle="tab"
                href="#curativo"
                role="tab"
                aria-controls="curativo"
                aria-selected="false"
                >Curativo</a
              > -->
              <!-- <a
                @click="errors = []"
                class="nav-link link-annotation-annotation"
                id="nav-troca-de-fralda"
                data-toggle="tab"
                href="#troca-de-fralda"
                role="tab"
                aria-controls="troca-de-fralda"
                aria-selected="false"
                >Troca de Fralda</a
              > -->
              <a
                v-if="care.finish_by_check == 0"
                @click="errors = []"
                class="nav-link link-annotation-annotation"
                id="nav-resumo-da-anotacao-termino"
                data-toggle="tab"
                href="#resumo-da-anotacao-termino"
                role="tab"
                aria-controls="resumo-da-anotacao-termino"
                aria-selected="false"
                >Resumo da Anotação / Término</a
              >
            </div>
          </nav>
          <div class="tab-content">
            <div
              :class="[
                'tab-pane fade',
                care.finish_by_check == 0 && 'show active',
              ]"
              id="passagem-de-plantao"
              role="tabpanel"
              aria-labelledby="nav-passagem-de-plantao"
            >
              <div class="row">
                <b-modal
                  no-close-on-backdrop
                  hide-footer
                  id="passagem-de-plantao"
                  title="PASSAGEM DE PLANTÃO"
                >
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>PERÍODO:</h6>
                      <div class="row ml-1">
                        <vs-radio
                          :disabled="statusCare == 'F' || !$store.state.online"
                          v-model="shift_change_beginning_or_end"
                          vs-value="INICIO"
                          class="m-2"
                          >INÍCIO</vs-radio
                        >
                        <vs-radio
                          :disabled="statusCare == 'F' || !$store.state.online"
                          v-model="shift_change_beginning_or_end"
                          vs-value="FIM"
                          class="m-2"
                          >FIM</vs-radio
                        >
                      </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>RESIDENTE ESTÁ:</h6>
                      <select
                        :disabled="statusCare == 'F' || !$store.state.online"
                        v-model="place"
                        @change="handleChangePlace"
                        class="form-control"
                      >
                        <option value data-name>SELECIONE...</option>
                        <option
                          :key="item.id"
                          :value="item.name"
                          :data-name="item.name"
                          v-for="item in places"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-show="show_other_place"
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-0 pr-0"
                      >
                        <h6>LOCAL:</h6>
                        <input
                          v-model="other_place"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>CONDIÇÃO:</h6>
                      <div class="row">
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_ACORDADO"
                            v-model="shift_change_ACORDADO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_ACORDADO"
                            >ACORDADO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_AGITADO"
                            v-model="shift_change_AGITADO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_AGITADO"
                            >AGITADO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_CALMO"
                            v-model="shift_change_CALMO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_CALMO"
                            >CALMO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_CONTACTUADO"
                            v-model="shift_change_CONTACTUADO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_CONTACTUADO"
                            >CONTACTUANDO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_DEAMBULANDO"
                            v-model="shift_change_DEAMBULANDO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_DEAMBULANDO"
                            >DEAMBULANDO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_DORMINDO"
                            v-model="shift_change_DORMINDO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_DORMINDO"
                            >DORMINDO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_HIDRATADO"
                            v-model="shift_change_HIDRATADO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_HIDRATADO"
                            >HIDRATADO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_SENTADO"
                            v-model="shift_change_SENTADO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_SENTADO"
                            >SENTADO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_SONOLENTO"
                            v-model="shift_change_SONOLENTO"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_SONOLENTO"
                            >SONOLENTO</label
                          >
                        </div>
                        <div class="check-box-annotation">
                          <input
                            :disabled="
                              statusCare == 'F' || !$store.state.online
                            "
                            class="form-check-input mb-2"
                            type="checkbox"
                            id="shift_change_OUTROS"
                            v-model="shift_change_OUTROS"
                            @input="handleChangeShiftChangeResponse"
                          />
                          <label
                            class="form-check-label"
                            for="shift_change_OUTROS"
                            >OUTROS</label
                          >
                        </div>
                      </div>
                      <div
                        v-show="shift_change_OUTROS == true"
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-0 pr-0"
                      >
                        <h6 class="upper-text">Informe a condição:</h6>
                        <input
                          v-model="other_shift_change_response"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
                    >
                      <ErrorsMessages :errors="errors" />
                    </div>
                    <div
                      class="col-md-12 d-flex justify-content-end align-items-center pt-0"
                    >
                      <v-btn
                        :disabled="
                          loadingShiftChange ||
                          !permission('edit', 'resident_annotation') ||
                          statusCare == 'F' ||
                          !$store.state.online
                        "
                        class="btn-add"
                        @click="handleAddShiftChange"
                      >
                        <i class="fas fa-check mr-2 text-twenty"></i>
                        ADICIONAR
                      </v-btn>
                    </div>
                  </div>
                </b-modal>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <v-btn
                    class="float-right btn-save"
                    @click="handleOpenModal('passagem-de-plantao')"
                    ><i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR
                  </v-btn>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_shift_change.length == 0"
                >
                  <div class="p-5 v-clean">
                    <h6 class="text-center upper-text worksansr">
                      Nenhuma informação adicionada.
                    </h6>
                  </div>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_shift_change.length > 0"
                >
                  <v-data-table
                    dense
                    :headers="[
                      {
                        text: 'PERÍODO',
                        value: 'beginning_or_end',
                      },
                      {
                        text: 'RESIDENTE ESTÁ',
                        value: 'place',
                      },
                      {
                        text: 'CONDIÇÃO',
                        value: 'response',
                      },
                      {
                        text: 'DATA CADASTRO',
                        value: 'created_at',
                      },
                      {
                        text: '',
                        value: 'action',
                      },
                    ]"
                    :items="care_has_shift_change"
                    :footer-props="{
                      'items-per-page-options': [50, 75, 100],
                      'items-per-page-text': 'Mostrar',
                    }"
                  >
                    <template v-slot:[`item.created_at`]="{ item }">{{
                      formatDate(item.created_at)
                    }}</template>
                    <template v-slot:[`item.action`]="{ item }">
                      <LinkVerLocalizacaoRegistro :item="item" />
                      <div v-if="care.status != 'F'">
                        <confirmation-dialog
                          v-if="$store.state.online"
                          small
                          message-title="EXCLUIR?"
                          message-body="Deseja realmente remover?"
                          open-class="btn-delete"
                          open-left-icon="fa-trash"
                          open-text="EXCLUIR"
                          @yes="deleteShiftChange(item.id)"
                        />
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
            <div
              :class="[
                'tab-pane fade',
                care.finish_by_check == 1 && 'show active',
              ]"
              id="anotacao"
              role="tabpanel"
              aria-labelledby="nav-anotacao"
            >
              <div class="row">
                <div class="col-md-12">
                  <ChromeSpeechToTextTextarea
                    :disabled="statusCare == 'F' || !$store.state.online"
                    rows="4"
                    max-rows="10"
                    v-model="annotation"
                  />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mb-0 worksansr upper-text text-fourteen">
                    Anotação feita por:
                    <strong>
                      {{
                        professionalClassCouncilValue({
                          id: care.user_professional_class_council_id,
                          name: care.user_name,
                          profile: care.user_profile_name,
                          office: care.user_office,
                          cpf: care.user_cpf,
                          value: care.user_professional_class_council_value,
                        })
                      }}
                      -
                      {{ formatDate(care.created_at) }}
                    </strong>
                  </h6>
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    :disabled="
                      !$store.state.online ||
                      loadingUpdate ||
                      !permission('edit', 'resident_annotation') ||
                      statusCare == 'F'
                    "
                    @click="update"
                    class="btn-save"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingUpdate ? "Carregando" : "SALVAR" }}
                  </v-btn>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="alimentacao"
              role="tabpanel"
              aria-labelledby="nav-alimentacao"
            >
              <div class="row">
                <b-modal
                  no-close-on-backdrop
                  hide-footer
                  id="alimentacao"
                  title="ALIMENTAÇÃO"
                >
                  <div class="row">
                    <div
                      v-if="resident_type_of_food"
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                    >
                      Tipo de alimentação:
                      <strong>{{ resident_type_of_food }}</strong>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>HORÁRIO DA REFEIÇÃO:</h6>
                      <select
                        :disabled="!$store.state.online || care.status == 'F'"
                        v-model="feeding_care_id"
                        @change="handleChangeFeedingCare"
                        class="form-control"
                      >
                        <option value data-name>SELECIONE...</option>
                        <option
                          :key="item.id"
                          :value="item.id"
                          :data-name="item.name"
                          v-for="item in feeding_cares"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>ACEITOU A REFEIÇÃO?</h6>
                      <div class="input-group">
                        <select
                          :disabled="!$store.state.online || care.status == 'F'"
                          v-model="feeding_care_response"
                          class="form-control"
                        >
                          <option value>SELECIONE...</option>
                          <option
                            :key="item.id"
                            :value="item.response"
                            v-for="item in feeding_care_responses"
                          >
                            {{ item.response }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <ErrorsMessages :errors="errors" />
                    </div>
                    <div
                      class="col-md-12 d-flex justify-content-end align-items-center pt-0"
                    >
                      <v-btn
                        :disabled="
                          loadingFeedingCare ||
                          !permission('edit', 'resident_annotation') ||
                          !$store.state.online ||
                          care.status == 'F'
                        "
                        class="btn-add"
                        @click="handleAddFeedingCare"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i>
                        ADICIONAR
                      </v-btn>
                    </div>
                  </div>
                </b-modal>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <v-btn
                    class="float-right btn-save"
                    @click="handleOpenModal('alimentacao')"
                    ><i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR
                  </v-btn>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_feeding_care.length == 0"
                >
                  <div class="p-5 v-clean">
                    <h6 class="text-center upper-text worksansr">
                      Nenhuma informação adicionada.
                    </h6>
                  </div>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_feeding_care.length > 0"
                >
                  <v-data-table
                    dense
                    :headers="[
                      {
                        text: 'Refeição',
                        value: 'feeding_care_name',
                      },
                      {
                        text: 'Aceitou a refeição?',
                        value: 'response',
                      },
                      {
                        text: 'Data cadastro',
                        value: 'created_at',
                      },
                      {
                        text: '',
                        value: 'action',
                      },
                    ]"
                    :items="care_has_feeding_care"
                    :footer-props="{
                      'items-per-page-options': [50, 75, 100],
                      'items-per-page-text': 'Mostrar',
                    }"
                  >
                    <template v-slot:[`item.created_at`]="{ item }">{{
                      formatDate(item.created_at)
                    }}</template>
                    <template v-slot:[`item.action`]="{ item }">
                      <LinkVerLocalizacaoRegistro :item="item" />
                      <div v-if="care.status != 'F'">
                        <confirmation-dialog
                          v-if="$store.state.online"
                          small
                          message-title="EXCLUIR?"
                          message-body="Deseja realmente remover?"
                          open-class="btn-delete"
                          open-left-icon="fa-trash"
                          open-text="EXCLUIR"
                          @yes="deleteFeedingCare(item.id)"
                        />
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="banho"
              role="tabpanel"
              aria-labelledby="nav-banho"
            >
              <div class="row">
                <b-modal
                  no-close-on-backdrop
                  hide-footer
                  id="banho"
                  title="BANHO"
                >
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>TURNO:</h6>
                      <select
                        :disabled="statusCare == 'F' || !$store.state.online"
                        v-model="shift"
                        class="form-control"
                      >
                        <option value data-name>SELECIONE...</option>
                        <option
                          :key="item.id"
                          :value="item.name"
                          :data-name="item.name"
                          v-for="item in shifts"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <h6>TIPO:</h6>
                      <div class="input-group">
                        <select
                          :disabled="statusCare == 'F' || !$store.state.online"
                          v-model="bath_type"
                          class="form-control"
                        >
                          <option value>SELECIONE...</option>
                          <option
                            :key="item.id"
                            :value="item.name"
                            v-for="item in bath_types"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <ErrorsMessages :errors="errors" />
                    </div>
                    <div
                      class="col-md-12 d-flex justify-content-end align-items-center pt-0"
                    >
                      <v-btn
                        :disabled="
                          loadingBath ||
                          !permission('edit', 'resident_annotation') ||
                          statusCare == 'F' ||
                          !$store.state.online
                        "
                        class="btn-add"
                        @click="handleAddBath"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i>
                        ADICIONAR
                      </v-btn>
                    </div>
                  </div>
                </b-modal>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <v-btn
                    class="float-right btn-save"
                    @click="handleOpenModal('banho')"
                    ><i class="fas fa-plus mr-2 text-twenty"></i>
                    ADICIONAR
                  </v-btn>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_bath.length == 0"
                >
                  <div class="p-5 v-clean">
                    <h6 class="text-center upper-text worksansr">
                      Nenhuma informação adicionada.
                    </h6>
                  </div>
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="care_has_bath.length > 0"
                >
                  <v-data-table
                    dense
                    :headers="[
                      { text: 'Turno', value: 'shift' },
                      { text: 'Tipo', value: 'bath_type' },
                      {
                        text: 'Data cadastro',
                        value: 'created_at',
                      },
                      {
                        text: '',
                        value: 'action',
                      },
                    ]"
                    :items="care_has_bath"
                    :footer-props="{
                      'items-per-page-options': [50, 75, 100],
                      'items-per-page-text': 'Mostrar',
                    }"
                  >
                    <template v-slot:[`item.created_at`]="{ item }">{{
                      formatDate(item.created_at)
                    }}</template>
                    <template v-slot:[`item.action`]="{ item }">
                      <LinkVerLocalizacaoRegistro :item="item" />
                      <div v-if="care.status != 'F'">
                        <confirmation-dialog
                          v-if="$store.state.online"
                          small
                          message-title="EXCLUIR?"
                          message-body="Deseja realmente remover?"
                          open-class="btn-delete"
                          open-left-icon="fa-trash"
                          open-text="EXCLUIR"
                          @yes="deleteBath(item.id)"
                        />
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="resumo-da-anotacao-termino"
              role="tabpanel"
              aria-labelledby="nav-resumo-da-anotacao-termino"
            >
              <div class="row">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-if="
                    care.status == 'A' &&
                    (!care_has_shift_change_init || !care_has_shift_change_end)
                  "
                >
                  <WarningMessage
                    v-if="
                      !care_has_shift_change_init &&
                      createdAt &&
                      statusCare == 'A'
                    "
                    message="Não se esqueça de Assumir o plantão!!!"
                  />
                  <WarningMessage
                    v-if="
                      !care_has_shift_change_end &&
                      createdAt &&
                      statusCare == 'A'
                    "
                    message=" Não se esqueça de fazer o encerramento do plantão!!!"
                  />
                </div>

                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                >
                  <h6 class="status-care">
                    STATUS:
                    {{ care.status == "A" ? "EM ABERTO" : "FINALIZADO" }}
                  </h6>
                  <span class="worksansr upper-text weight-600">
                    Assumo o plantão, cliente {{ resident_name }} no(a)
                  </span>
                  <span
                    v-for="(item, key) in care_has_shift_change"
                    :key="`${key}-${generateId()}`"
                    class="worksansr upper-text"
                    v-show="item.beginning_or_end == 'INICIO'"
                    >{{ item.place }} - {{ item.response }};</span
                  >
                  <span
                    v-for="(item, key) in care_has_feeding_care"
                    :key="`${key}-${generateId()}`"
                    class="worksansr upper-text"
                  >
                    {{ item.feeding_care_name }}: {{ item.response }} ({{
                      formatDate(item.created_at)
                    }});
                  </span>

                  <span
                    v-for="(item, key) in care_has_bath"
                    :key="`${key}-${generateId()}`"
                    class="worksansr upper-text pr-1"
                    >Realizado o banho de {{ item.bath_type }} pela
                    {{ item.shift }} ({{ formatDate(item.created_at) }});</span
                  >
                  <h6 class="upper-text mt-2">
                    Observação:
                    <span class="worksansr upper-text">{{ annotation }}</span>
                  </h6>
                </div>

                <div
                  v-if="care_has_shift_change_end"
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                >
                  <span class="worksansr upper-text weight-600">
                    Encerro o plantão, cliente
                    {{ resident_name }} no(a)
                  </span>
                  <span
                    v-for="(item, key) in care_has_shift_change"
                    :key="`${key}-${generateId()}`"
                    class="worksansr upper-text"
                    v-show="item.beginning_or_end == 'FIM'"
                    >{{ item.place }} - {{ item.response }};</span
                  >
                </div>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3"
                >
                  <h6 class="mb-0 text-thirteen">
                    {{
                      professionalClassCouncilValue({
                        id: care.user_professional_class_council_id,
                        name: care.user_name,
                        value: care.user_professional_class_council_value,
                        cpf: care.user_cpf,
                        office: care.user_office,
                      })
                    }}
                    -
                    {{ formatDate(care.updated_at) }}
                  </h6>
                  <span class="upper-text text-eleven"
                    >(Assinatura eletrônica)</span
                  >
                </div>
                <div v-show="care.status == 'F'" class="col-md-12">
                  <h5>Anotações</h5>
                  <vs-collapse type="border">
                    <vs-collapse-item
                      v-for="item in annotations"
                      :key="item.id"
                    >
                      <div slot="header">
                        Observação feita por: {{ item.user_name }}
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <strong>Observação:</strong>
                          {{ item.annotation }}
                        </div>
                        <div class="col-md-12">
                          (Assinatura eletrônica)
                          <span class="signature-coren">
                            {{
                              professionalClassCouncilValue({
                                id: item.user_professional_class_council_id,
                                name: item.user_name,
                                profile: item.user_profile_name,
                                cpf: item.user_cpf,
                                office: item.user_office,
                                value:
                                  item.user_professional_class_council_value,
                              })
                            }}
                          </span>
                        </div>
                        <div class="col-md-12">
                          <h6 class="mb-0 worksansr">
                            Criação:
                            {{ formatDate(item.created_at) }}
                          </h6>
                        </div>
                        <div class="col-md-12">
                          <LinkVerLocalizacaoRegistro :item="item" />
                        </div>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
                <div class="col-md-6">
                  <h6 class="mb-0 worksansr">
                    Criação:
                    {{ formatDate(care.created_at) }}
                  </h6>
                  <h6 class="mb-0 worksansr">
                    Última alteração:
                    {{ formatDate(care.updated_at) }}
                  </h6>
                </div>
                <div class="col-md-6 text-right">
                  <ButtonGenerateCertificate
                    v-if="care && care.data_base64"
                    :data_base64="
                      care && care.data_base64 ? care.data_base64 : ''
                    "
                  />
                  <v-btn
                    v-if="$store.state.online"
                    :disabled="!permission('read', 'resident_annotation')"
                    v-on:click="print"
                    class="btn-print m-2"
                  >
                    <i class="fas fa-print mr-2 text-twenty"></i>
                    IMPRIMIR
                  </v-btn>
                  <v-btn
                    :disabled="
                      loadingFinishCare ||
                      care.status == 'F' ||
                      !permission('edit', 'resident_annotation') ||
                      !$store.state.online
                    "
                    v-on:click="errors = []"
                    @click="$bvModal.show('popupFinishAnnotation')"
                    class="btn-save m-2"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    FINALIZAR
                  </v-btn>
                  <confirmation-dialog
                    :disabled="
                      loadingFinishCare ||
                      care.status == 'F' ||
                      !permission('edit', 'resident_annotation') ||
                      !$store.state.online
                    "
                    v-if="
                      permission('read', 'master_finish_annotation') &&
                      care.status == 'A' &&
                      $store.state.online &&
                      care.user_id != user_id
                    "
                    message-title="FINALIZAR?"
                    message-body="Deseja realmente finalizar o cuidado? Ao confirmar, não podera realizar quaisquer alterações!"
                    open-class="btn-notcertified"
                    open-left-icon="fa-check"
                    open-text="FINALIZAR COMO MASTER"
                    @yes="finishCareAnnotationByMaster"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";
import WarningMessage from "../../../Components/WarningMessage";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../../../Components/ConfirmationDialog";

import ButtonGenerateCertificate from "../../../Components/ButtonGenerateCertificate";

import LinkVerLocalizacaoRegistro from "../../../Components/LinkVerLocalizacaoRegistro";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import {
  formatDate,
  generateId,
  formatDateOnlyNumbers,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import permission from "../../../../lib/permission";

import { digitalCertificate } from "../../../../lib/digital-certificate";

import routes from "../../../../routes";

import { userData } from "../../../../lib/functions";

import moment from "moment";

export default {
  name: "Annotation",
  components: {
    ErrorsMessages,
    WarningMessage,
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ButtonGenerateCertificate,
    LinkVerLocalizacaoRegistro,
  },
  props: {
    id: [String, Number],
    care: Object,
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    resident_name: [String, Number],
    resident_type_of_food: [String, Number],
    user: Object,
    createdAt: [Boolean],
    statusCare: [String, Number],
  },
  data() {
    return {
      user_id: null,

      searchMedicines: "",
      searchProducts: "",
      shifts: [
        { id: 1, name: "MANHÃ" },
        { id: 2, name: "TARDE" },
        { id: 3, name: "NOITE" },
        { id: 4, name: "MADRUGADA" },
      ],
      bath_types: [
        { id: 1, name: "ASPERSÃO" },
        { id: 2, name: "LEITO" },
      ],
      places: [
        { id: 1, name: "AUSENTE" },
        { id: 2, name: "SALA" },
        { id: 3, name: "BANHEIRO" },
        { id: 4, name: "QUINTAL" },
        { id: 5, name: "LEITO" },
        { id: 6, name: "OUTROS" },
      ],
      shift_change_SONOLENTO: false,
      shift_change_DORMINDO: false,
      shift_change_ACORDADO: false,
      shift_change_AGITADO: false,
      shift_change_CONTACTUADO: false,
      shift_change_SENTADO: false,
      shift_change_HIDRATADO: false,
      shift_change_DEAMBULANDO: false,
      shift_change_CALMO: false,
      shift_change_OUTROS: false,
      feeding_care_responses: [
        { id: 1, response: "ACEITOU PARCIAL" },
        { id: 2, response: "BOA ACEITAÇÃO" },
        { id: 3, response: "NÃO ACEITOU" },
        { id: 4, response: "RESIDENTE AUSENTE" },
      ],
      annotations: [],
      medicines: [],
      feeding_cares: [],
      shift_changes: [],
      baths: [],
      annotation: "",
      feeding_care_id: "",
      feeding_care_response: "",
      feeding_care_response_name: "",
      shift: "",
      bath_type: "",
      shift_change_beginning_or_end: "",
      place: "",
      shift_change_response: "",
      other_place: "",
      other_shift_change_response: "",
      show_other_place: false,
      show_other_shift_change_response: false,
      care_has_medicine: [],
      care_has_bath: [],
      care_has_shift_change: [],
      care_has_shift_change_init: false,
      care_has_shift_change_end: false,
      care_has_feeding_care: [],
      loading: true,
      loadingUpdate: false,
      loadingFinishCare: false,
      loadingShiftChange: false,
      loadingBath: false,
      loadingFeedingCare: false,
      feeding_care_date: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  watch: {
    care: function () {
      this.retrieve();
    },
  },
  methods: {
    formatDate,
    generateId,
    permission,
    formatDateOnlyNumbers,
    professionalClassCouncilValue,
    handleOpenModal(id) {
      this.shift_change_beginning_or_end = "";
      this.place = "";
      this.shift_change_SONOLENTO = false;
      this.shift_change_DORMINDO = false;
      this.shift_change_ACORDADO = false;
      this.shift_change_AGITADO = false;
      this.shift_change_CONTACTUADO = false;
      this.shift_change_SENTADO = false;
      this.shift_change_HIDRATADO = false;
      this.shift_change_DEAMBULANDO = false;
      this.shift_change_CALMO = false;
      this.shift_change_OUTROS = false;

      this.feeding_care_id = "";
      this.feeding_care_response = "";

      this.shift = "";
      this.bath_type = "";

      this.$bvModal.show(id);
    },
    async deleteAnnotation() {
      try {
        const { id } = this;

        let data = { id };

        const response = await api.delete("/rest-home/annotation", {
          data,
        });

        const { error, errors } = response.data;

        if (!error) {
          return routes.go(-1);
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    handleChangePlace(e) {
      const { value } = e.target;

      if (value == "OUTROS") {
        this.show_other_place = true;
      } else {
        this.show_other_place = false;
      }
    },
    handleChangeShiftChangeResponse(e) {
      const { value } = e.target;

      if (value == "OUTROS") {
        this.show_other_shift_change_response = true;
      } else {
        this.show_other_shift_change_response = false;
      }
    },
    handleChangeFeedingCare(e) {
      const { options } = e.target;
      const { selectedIndex } = e.target.options;

      var option = options[selectedIndex];

      if (option.value == 6) {
        if (
          parseInt(formatDateOnlyNumbers(this.care.created_at)) <
          parseInt(formatDateOnlyNumbers(new Date()))
        ) {
          this.feeding_care_date = true;
        } else {
          this.feeding_care_date = false;
        }
      } else {
        this.feeding_care_date = false;
      }

      this.feeding_care_response_name = option.dataset.name;
    },
    async retrieve() {
      this.user_id = userData().user.id;

      if (permission("read", "resident_annotation")) {
        if (!this.$store.state.online) {
          let { care } = this;

          this.care_has_bath = care.care_has_bath;
          this.care_has_shift_change = care.care_has_shift_change;
          this.care_has_feeding_care = care.care_has_feeding_care;
          this.annotation = care.annotation;

          this.loading = false;
        } else {
          if (this.errors.length == 0) await this.get();
          if (this.errors.length == 0) await this.getFeedingCares();
        }
      }
    },
    async get() {
      try {
        this.loading = true;

        const {
          id,
          care: { resident_id, created },
        } = this;

        var params = {
          id,
          resident_id,
          created,
        };

        const response = await api.get("/rest-home/care/annotation/get", {
          params,
        });

        const {
          error,
          care_has_medicine,
          care_has_bath,
          care_has_shift_change,
          care_has_feeding_care,
          annotations,
        } = response.data;

        if (error) {
          return routes.go(-1);
        }

        this.care_has_medicine = care_has_medicine;
        this.care_has_bath = care_has_bath;
        this.care_has_shift_change = care_has_shift_change;

        this.care_has_shift_change_init = false;
        this.care_has_shift_change_end = false;

        if (care_has_shift_change.length > 0) {
          care_has_shift_change.forEach((item) => {
            if (item.beginning_or_end == "INICIO") {
              this.care_has_shift_change_init = item;
            }

            if (item.beginning_or_end == "FIM") {
              this.care_has_shift_change_end = item;
            }
          });
        }

        this.care_has_feeding_care = care_has_feeding_care;
        this.annotations = annotations;
        this.annotation = this.care.annotation;

        this.$bvModal.hide("passagem-de-plantao");
        this.$bvModal.hide("alimentacao");
        this.$bvModal.hide("banho");

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getFeedingCares() {
      try {
        const response = await api.get("/feeding-cares");

        const { error, errors, feeding_cares } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.feeding_cares = feeding_cares;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleAddFeedingCare() {
      try {
        this.loadingFeedingCare = true;

        const {
          id: care_id,
          feeding_care_id,
          feeding_care_response,
          feeding_care_date,
          user,
          resident_id,
        } = this;

        var params = {
          care_id,
          feeding_care_id,
          response: feeding_care_response,
          feeding_care_date,
          user_id: user.id,
          resident_id,
        };

        const response = await api.post(
          "/rest-home/care/feeding/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
          this.feeding_care_id = "";
          this.feeding_care_response = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingFeedingCare = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteFeedingCare(id) {
      try {
        const { id: care_id, user } = this;

        let data = { id, care_id, user_id: user.id };

        if (this.care.status == "F") {
          this.errors = [
            {
              id: this.errors.length + 1,
              message:
                "Cuidado está como FINALIZADO, não pode realizar quaisquer alterações",
            },
          ];
          return;
        }

        if (!permission("edit", "resident_annotation")) {
          this.errors = [
            {
              id: this.errors.length + 1,
              message: "Você não tem permissão",
            },
          ];
          return;
        }

        const response = await api.delete("/rest-home/care/feeding/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleAddBath() {
      try {
        this.loadingBath = true;

        const { id: care_id, shift, bath_type, user, resident_id } = this;

        var params = {
          care_id,
          shift,
          bath_type,
          user_id: user.id,
          resident_id,
        };

        const response = await api.post("/rest-home/care/bath/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
          this.shift = "";
          this.bath_type = "";
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingBath = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteBath(id) {
      try {
        const { id: care_id, user } = this;

        let data = { id, care_id, user_id: user.id };

        if (this.care.status == "F") {
          this.errors = [
            {
              id: this.errors.length + 1,
              message:
                "Cuidado está como FINALIZADO, não pode realizar quaisquer alterações",
            },
          ];
          return;
        }

        if (!permission("edit", "resident_annotation")) {
          this.errors = [
            {
              id: this.errors.length + 1,
              message: "Você não tem permissão",
            },
          ];
          return;
        }

        const response = await api.delete("/rest-home/care/bath/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleAddShiftChange() {
      try {
        this.loadingShiftChange = true;

        const {
          id: care_id,
          shift_change_beginning_or_end: beginning_or_end,
          place,
          other_shift_change_response,
          shift_change_SONOLENTO,
          shift_change_DORMINDO,
          shift_change_ACORDADO,
          shift_change_AGITADO,
          shift_change_CONTACTUADO,
          shift_change_SENTADO,
          shift_change_HIDRATADO,
          shift_change_DEAMBULANDO,
          shift_change_CALMO,
          shift_change_OUTROS,
          show_other_place,
          other_place,
          user,
          resident_id,
        } = this;

        var shift_change_response = [];

        if (shift_change_ACORDADO) {
          shift_change_response.push("ACORDADO, ");
        }

        if (shift_change_AGITADO) {
          shift_change_response.push("AGITADO, ");
        }

        if (shift_change_CALMO) {
          shift_change_response.push("CALMO, ");
        }

        if (shift_change_CONTACTUADO) {
          shift_change_response.push("CONTACTUANDO, ");
        }

        if (shift_change_DEAMBULANDO) {
          shift_change_response.push("DEAMBULANDO, ");
        }

        if (shift_change_DORMINDO) {
          shift_change_response.push("DORMINDO, ");
        }

        if (shift_change_HIDRATADO) {
          shift_change_response.push("HIDRATADO, ");
        }

        if (shift_change_SENTADO) {
          shift_change_response.push("SENTADO, ");
        }

        if (shift_change_SONOLENTO) {
          shift_change_response.push("SONOLENTO, ");
        }

        if (shift_change_OUTROS) {
          if (!other_shift_change_response) {
            this.errors = [
              {
                id: this.errors.length + 1,
                message: "INFORME A CONDIÇÃO (OUTROS)",
              },
            ];
            this.loadingShiftChange = false;
            return;
          }

          shift_change_response.push(
            String(other_shift_change_response).toUpperCase()
          );
        }

        if (shift_change_response.length > 0) {
          if (!shift_change_OUTROS) {
            shift_change_response[shift_change_response.length - 1] =
              shift_change_response[shift_change_response.length - 1].replace(
                ", ",
                ""
              );
          }
        }

        var _place = place;

        if (show_other_place) {
          if (!other_place) {
            this.errors = [
              { id: this.errors.length + 1, message: "INFORME O LOCAL" },
            ];
            this.loadingShiftChange = false;
            return;
          }

          _place = other_place;
        }

        var params = {
          care_id,
          beginning_or_end,
          place: _place,
          response: shift_change_response,
          user_id: user.id,
          resident_id,
        };

        const response = await api.post(
          "/rest-home/care/shift-change/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
          this.shift_change_beginning_or_end = "";
          this.place = "";
          this.shift_change_SONOLENTO = false;
          this.shift_change_DORMINDO = false;
          this.shift_change_ACORDADO = false;
          this.shift_change_AGITADO = false;
          this.shift_change_CONTACTUADO = false;
          this.shift_change_SENTADO = false;
          this.shift_change_HIDRATADO = false;
          this.shift_change_DEAMBULANDO = false;
          this.shift_change_CALMO = false;
          this.shift_change_OUTROS = false;
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingShiftChange = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteShiftChange(id) {
      try {
        const { id: care_id, user } = this;

        var data = { id, care_id, user_id: user.id };

        if (this.care.status == "F") {
          this.errors = [
            {
              id: this.errors.length + 1,
              message:
                "Cuidado está como FINALIZADO, não pode realizar quaisquer alterações",
            },
          ];
          return;
        }

        if (!permission("edit", "resident_annotation")) {
          this.errors = [
            {
              id: this.errors.length + 1,
              message: "Você não tem permissão",
            },
          ];
          return;
        }

        const response = await api.delete(
          "/rest-home/care/shift-change/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, annotation, user } = this;

        var params = { id, annotation, user_id: user.id };

        const response = await api.put("/rest-home/care/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$emit("change");
          toast(message, "success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async finishCareAnnotation() {
      try {
        this.loadingFinishCare = true;

        const { id } = this;

        var params = { id };

        const response = await api.patch(
          "/rest-home/care/annotation/finish",
          params
        );

        const { error, errors, message, item, items } = response.data;

        if (!error) {
          this.get();
          this.executeCertificate(item, items);
          this.$bvModal.hide("popupFinishAnnotation");
          toast(message, "success");
          this.$emit("change");
        } else {
          this.errors = errors;
        }

        this.loadingFinishCare = false;
      } catch (error) {
        console.log(error);
      }
    },
    async finishCareAnnotationByMaster() {
      try {
        this.loadingFinishCare = true;
        this.errors = [];

        const { id } = this;

        var params = { id };

        const response = await api.patch(
          "/rest-home/care/annotation/finish-master",
          params
        );

        const { error, errors, message, item, items } = response.data;

        if (!error) {
          this.get();
          this.executeCertificate(item, items);
          this.$bvModal.hide("popupFinishAnnotation");
          toast(message, "success");
          this.$emit("change");
        } else {
          this.errors = errors;
        }

        this.loadingFinishCare = false;
      } catch (error) {
        console.log(error);
      }
    },
    async executeCertificate(item, items) {
      if (!item) {
        return;
      }

      if (!items) {
        return;
      }

      let {
        care_has_shift_change,
        care_has_feeding_care,
        care_has_bath,
        annotation,
      } = items;

      let data = [];

      let rows = ["ASSUMO", "ALIMENTACAO", "BANHO", "OBSERVACAO", "ENCERRO"];

      for (let row of rows) {
        let text;

        if (row == "ASSUMO") {
          let find = care_has_shift_change.find(
            ({ beginning_or_end }) => beginning_or_end == "INICIO"
          );
          if (find) {
            text = `Assumo o plantão, cliente ${item.resident.name} no(a) ${find.place}, ${find.response}`;
          }
        } else if (row == "ALIMENTACAO") {
          text = `Alimentação: `;
          for (let feeding_care of care_has_feeding_care) {
            text += `${feeding_care.name}: ${feeding_care.response} (${moment(
              feeding_care.created_at
            ).format("DD/MM/YYYY HH:mm:ss")});`;
          }
        } else if (row == "BANHO") {
          text = `Banho: `;
          for (let bath of care_has_bath) {
            text += `Realizado banho de ${bath.bath_type} pela ${
              bath.shift
            } (${moment(bath.created_at).format("DD/MM/YYYY HH:mm:ss")});`;
          }
        } else if (row == "OBSERVACAO") {
          if (annotation) {
            text = `Observação: ${annotation}`;
          }
        } else if (row == "ENCERRO") {
          let find = care_has_shift_change.find(
            ({ beginning_or_end }) => beginning_or_end == "FIM"
          );
          if (find) {
            text = `Encerro o plantão, cliente ${item.resident.name} no(a) ${find.place}, ${find.response}`;
          }
        }

        data.push({
          col1: {
            exist: true,
            text,
          },
          col2: {
            exist: false,
            text: "",
          },
          col3: {
            exist: false,
            text: "",
          },
          col4: {
            exist: false,
            text: "",
          },
        });
      }

      await digitalCertificate({
        title: `CUIDADOS - ANOTAÇÃO DE CUIDADOS - ${moment(
          item.table.created_at
        ).format("DD/MM/YYYY")}`,
        data,
        exist_footer: false,
        item,
        created_at: item.table.created_at,
        signature: true,
      });
    },
    print() {
      const { id } = this;

      let route = this.$router.resolve({
        name: "print_care",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
    handleSerasaAnnotation() {
      window.open(
        `http://serasa-clin.sa-east-1.elasticbeanstalk.com/serasa/?redirect_to=https://portal.sistemaclin.com.br/serasa/annotation/confirm/${this.id}`,
        "Ratting",
        "width=550,height=550,left=150,top=200,toolbar=1,status=1,"
      );
    },
    handleToNewStock() {
      let route = this.$router.resolve({
        name: "new_stock",
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
.link-annotation-annotation {
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.status-care {
  text-transform: uppercase;
}
</style>
